export enum PackageTypeEnum {  
    BOX = "20",
    ABOUT = "10",
  }
  